import React from 'react';
import { connect } from 'react-redux';

import {
  selectIsAuthenticated,
  selectIsUserAdvanced,
  selectIsUserProfessional,
  selectUuid,
} from '../../redux/auth/user/selectors';
import { showUpdateSubscriptionModal } from '../../redux/ui/actions';

import CheckoutButtonProfessional from './CheckoutButtonProfessional';

const CheckoutButtonProfessionalConnected = (props) => <CheckoutButtonProfessional {...props} />;

const mapStateToProps = (state) => ({
  isAuthenticated: selectIsAuthenticated(state),
  isUserAdvanced: selectIsUserAdvanced(state),
  isUserProfessional: selectIsUserProfessional(state),
  uuid: selectUuid(state),
});

const mapActionsToProps = {
  showUpdateSubscriptionModal,
};

export default connect(mapStateToProps, mapActionsToProps)(CheckoutButtonProfessionalConnected);
